<b-modal
  v-model="modal_special_requirement_ADAS1"
  size="md"
  :header-bg-variant="headerColor"
  header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking
  >
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <ShowLessBOverlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid" style="min-height: 140px;">
        <div class="row no-gutters">
          <div class="col-12">
            <div class="text-left align-middle">
              <div class="box-margin-right work-support-message" style="white-space: break-spaces;">
                {{ bodyText }}
              </div>
            </div>
            <div v-if="phase === 'execute'" class="container-fluid mt-2 mb-2">
              <custom-Progress :value="progress" :max="progressMax" useResource />
            </div>
          </div>
        </div>
      </div>
    </ShowLessBOverlay>
  </template>

  <template v-slot:footer>
    <div class="w-100 text-center ">
      <!-- 実行監視 -->
      <template v-if="phase === 'start'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="standbyProcess" class="mx-2">
          {{ $t('individual.common_button_yes') }}
        </b-button>
        <b-button size="sm" :disabled="isLoading" variant="outline-primary" @click="closeWizard" class="mx-2">
          {{ $t('individual.common_button_no') }}
        </b-button>
      </template>
      <!-- 実行 -->
      <template v-if="phase === 'execute'">
      </template>
      <!-- 成功表示・失敗表示・共通エラー -->
      <template v-if="phase === 'success' || phase === 'failed_org' || phase === 'failed'">
        <b-button size="sm" :disabled="isLoading" variant="primary" @click="closeWizard" class="mx-2">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>